module.exports = ".add-new-player .form {\r\n  padding: 0 20px;\r\n}\r\n\r\n.add-new-player .form-action .btn {\r\n  min-width: 120px;\r\n}\r\n\r\n.add-new-player .form-group {\r\n  margin-bottom: 0;\r\n  padding: 15px 0;\r\n  border-bottom: 1px dashed #ddd;\r\n}\r\n\r\n.add-new-player .form .no-border {\r\n  border-bottom: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-player/add-player.component.css
// module id = ./src/app/shared/components/add-player/add-player.component.css
// module chunks = main